import { FieldStateTypes, HealthPlanStatuses, useMutation, useQueryClient } from '@common-fe/common-fe';
import { AxiosHeaders } from 'axios';
import _ from 'lodash';

import { api } from '@/api';
import ROUTES from '@/common/routes';
import { API_URL } from '@/dtos';
import { useHistory } from '@/modules/core/hooks';
import { useCurrentOrganisationStore } from '@/modules/core/store';
import { PlanByPlanYear } from '@/modules/HealthPlan/HealthPlan.types';
import { HEALTH_PLAN_LIST_QUERY_NAME } from '@/modules/HealthPlan/queries/useHealthPlansList.query';
import { QUERY_KEY as PLAN_YEAR_QUERY_KEY } from '@/modules/plan/PlanYearForm/queries/usePlanYears.query';

interface Payload {
  planYearId: number;
  parentId: number;
  name?: string;
  planType?: string;
  organizationId?: string;
  status?: HealthPlanStatuses;
}
export const useCreateHealthPlanMutations = (redirectMode?: boolean, includeLogHeader?: boolean) => {
  const queryClient = useQueryClient();
  const history = useHistory();
  const { organizationId } = useCurrentOrganisationStore();
  const mutation = useMutation(
    (data: Partial<Payload>) =>
      api.post<PlanByPlanYear>(
        API_URL.HEALTH_PLANS,
        {
          plan_year_id: data.planYearId,

          name: data.name
            ? {
                name: data.name,
                name_state: FieldStateTypes.Modifiable,
              }
            : undefined,

          parent_id: data.parentId,
          is_plan: true,
          plan_status: data.status,
          organization_id:
            data.organizationId || organizationId ? _.toNumber(data.organizationId || organizationId) : '',
        },
        {
          headers: includeLogHeader
            ? ({
                'Audit-Log-Creation': true,
              } as unknown as AxiosHeaders)
            : undefined,
        }
      ),
    {
      onSuccess: (response) => {
        const id = _.get(response, 'data.id');
        queryClient.invalidateQueries({
          queryKey: [HEALTH_PLAN_LIST_QUERY_NAME],
        });
        queryClient.invalidateQueries({
          queryKey: [PLAN_YEAR_QUERY_KEY],
        });
        if (redirectMode) {
          history.push(ROUTES.HEALTH_PLAN_SETUP_BY_ID(id));
        }
      },
    }
  );
  return mutation.mutateAsync;
};

export default useCreateHealthPlanMutations;
